import * as React from "react"

import { cn } from "@/lib/utils"
import { DISABLED, FOCUS_RING } from "@/components/ui/focusRing"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-lg border border-border bg-elevated px-4 py-3 text-control text-fg placeholder:text-fg-muted focus:border-border-strong transition-colors file:border-0 file:bg-transparent file:text-control file:font-medium file:text-fg",
          FOCUS_RING,
          DISABLED,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
